module.exports = __webpack_public_path__ + "static/media/secretaire.531c9476.jpg";